"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnvVar = getEnvVar;
/**
 * A utility for getting REACT_APP variables declared at runtime by the `{WORKSPACE_ROOT}/scripts/generate-react-app-runtime-vars.js`
 *
 *
 * Problem: We would like to be able to build a single docker image in CI pipeline and reuse it when it is
 * deployed to various environments (e.g. sg50, pr50, etc). This approach is in conflict with the way CRA apps
 * handle custom environment variables (https://create-react-app.dev/docs/adding-custom-environment-variables/).
 *
 * In order to handle this, we may inject global variables and set them on the `window._runtimeReactVariables` object.
 * If the object does not exist, or the key does not exist, we try the "normal" CRA approach by looking for the variable
 * on the `process.env` object.
 *
 * Example variable:
 *
 * `window._runtimeReactVariables.REACT_APP_SF_REALTIME_ENDPOINT`
 *
 * So we first look for the variable here:
 *
 * `window._runtimeReactVariables.REACT_APP_SF_REALTIME_ENDPOINT`
 *
 * and then if that is not found, we look here:
 *
 * `process.env.REACT_APP_SF_REALTIME_ENDPOINT`
 *
 * @param {*} varName
 * @returns
 */
function getEnvVar(varName) {
  return (window._runtimeReactVariables || {})[varName] || process.env[varName];
}